(function () {
  'use strict';

  var LK = window.LK || {};
  var routes = LK.routes || { cart: '/cart', cartAdd: '/cart/add', root: '/' };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount_with_comma_separator}} zł';
    var re = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(re);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return format.replace(re, value).replace(/<[^>]*>/g, '');
  }
  function money(c) { return formatMoney(c, LK.moneyFormat); }

  /* ---------- Cart ---------- */
  function addItems(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka.');
        return data;
      });
    });
  }

  function afterAdd(redirect) {
    if (redirect === 'checkout') { window.location.href = '/checkout'; return; }
    if (redirect === 'stay') {
      toast('Dodano do koszyka. <a href="' + routes.cart + '">Przejdź do koszyka</a>');
      updateCount();
      return;
    }
    window.location.href = routes.cart;
  }

  function updateCount() {
    fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector('.lk-cart-link');
        if (!link) return;
        var badge = link.querySelector('.lk-cart-count');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lk-cart-count';
          link.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'lk-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.style.pointerEvents = 'auto';
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      toastEl.style.pointerEvents = 'none';
    }, 4000);
  }

  /* ---------- Product section ---------- */
  function once(el) { if (el.dataset.lkInit) return false; el.dataset.lkInit = '1'; return true; }

  function initProduct(root) {
    if (!once(root)) return;
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var dataEl = $('[data-lk-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[data-lk-variant-input]');
    var qtyInput = $('[data-lk-qty-input]');
    var variant = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var qty = parseInt(qtyInput.value, 10) || 1;
    var mainImg = $('[data-lk-main-img]');
    var btn = $('[data-lk-submit]');
    var btnText = $('[data-lk-submit-text]');
    var errorEl = $('[data-lk-error]');

    function render() {
      idInput.value = variant.id;
      qtyInput.value = qty;
      var priceEl = $('[data-lk-price]');
      if (priceEl) priceEl.textContent = money(variant.price * qty);
      var cmp = $('[data-lk-compare]');
      var save = $('[data-lk-save]');
      if (cmp && save) {
        if (variant.compare > variant.price) {
          cmp.hidden = false;
          cmp.textContent = money(variant.compare * qty);
          save.hidden = false;
          save.querySelector('span').textContent = money((variant.compare - variant.price) * qty);
        } else {
          cmp.hidden = true;
          save.hidden = true;
        }
      }
      btn.disabled = !variant.available;
      var atcBtn = $('[data-lk-atc]');
      if (atcBtn) atcBtn.disabled = !variant.available;
      btnText.textContent = variant.available ? btn.dataset.label : btn.dataset.soldout;
      $$('[data-lk-variant]').forEach(function (b) {
        var on = b.dataset.lkVariant === String(variant.id);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    $$('[data-lk-offer]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = parseInt(b.dataset.qty, 10) || 1;
        $$('[data-lk-offer]').forEach(function (o) {
          o.classList.toggle('is-active', o === b);
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');
        });
        render();
      });
    });

    $$('[data-lk-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variants.filter(function (x) { return String(x.id) === b.dataset.lkVariant; })[0];
        if (!v) return;
        variant = v;
        if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        render();
      });
    });

    $$('[data-lk-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.src;
        $$('[data-lk-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    function collectItems() {
      var items = [{ id: variant.id, quantity: qty }];
      var addon = $('[data-lk-addon]');
      if (addon && addon.checked) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
      return items;
    }

    var atc = $('[data-lk-atc]');
    if (atc) {
      atc.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;
        atc.classList.add('is-loading');
        addItems(collectItems())
          .then(function () {
            atc.classList.remove('is-loading');
            var label = atc.querySelector('span');
            label.textContent = 'Dodano ✓';
            setTimeout(function () { label.textContent = atc.dataset.label; }, 2200);
            afterAdd(atc.dataset.redirect || 'stay');
          })
          .catch(function (err) {
            atc.classList.remove('is-loading');
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });
    }

    var form = $('[data-lk-form]') || $('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var items = collectItems();
        btn.classList.add('is-loading');
        addItems(items)
          .then(function () { afterAdd(root.dataset.redirect || 'cart'); })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });
    }

    render();
  }

  /* ---------- Generic add-to-cart buttons ---------- */
  function initAddButtons() {
    document.querySelectorAll('[data-lk-add]').forEach(function (b) {
      if (!once(b)) return;
      b.addEventListener('click', function () {
        var items = b.dataset.lkAdd.split(',').map(function (pair) {
          var p = pair.split(':');
          return { id: parseInt(p[0], 10), quantity: parseInt(p[1] || '1', 10) };
        }).filter(function (i) { return i.id; });
        if (!items.length) return;
        b.classList.add('is-loading');
        addItems(items)
          .then(function () { b.classList.remove('is-loading'); afterAdd(b.dataset.redirect || 'cart'); })
          .catch(function (err) { b.classList.remove('is-loading'); toast(err.message); });
      });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-lk-tabs]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var btns = wrap.querySelectorAll('[data-tab]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          wrap.querySelectorAll('[data-panel]').forEach(function (p) {
            p.hidden = p.dataset.panel !== b.dataset.tab;
          });
        });
      });
    });
  }

  /* ---------- Drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-lk-drawer]');
    var openBtn = document.querySelector('[data-lk-menu-open]');
    if (!drawer || !openBtn || !once(openBtn)) return;
    function close() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', function () {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    drawer.querySelectorAll('[data-lk-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Before / after slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-lk-ba]').forEach(function (el) {
      if (!once(el)) return;
      var range = el.querySelector('.lk-ba__range');
      if (!range) return;
      var set = function () { el.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      var dragging = false, startX = 0, startY = 0, decided = false;
      function fromX(x) {
        var r = el.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        range.value = pct;
        set();
      }
      el.addEventListener('pointerdown', function (e) {
        dragging = true; decided = e.pointerType === 'mouse';
        startX = e.clientX; startY = e.clientY;
        if (decided) { fromX(e.clientX); el.setPointerCapture(e.pointerId); }
      });
      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; }
          decided = true;
          try { el.setPointerCapture(e.pointerId); } catch (err) {}
        }
        fromX(e.clientX);
      });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        el.addEventListener(t, function (e) {
          if (dragging && !decided && e.type === 'pointerup') fromX(e.clientX);
          dragging = false;
        });
      });
      set();
    });
  }

  /* ---------- Video unmute ---------- */
  function initVideos() {
    document.querySelectorAll('[data-lk-unmute]').forEach(function (b) {
      if (!once(b)) return;
      var video = b.parentNode.querySelector('video');
      if (!video) { b.hidden = true; return; }
      b.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) { video.currentTime = 0; video.play(); }
        b.classList.toggle('is-on', !video.muted);
        b.querySelector('span').textContent = video.muted ? 'Włącz dźwięk' : 'Wycisz';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lk-product]').forEach(initProduct);
    initBeforeAfter();
    initVideos();
    initAddButtons();
    initTabs();
    initDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
